import React, { FC, ReactNode, useEffect, useState } from 'react';
import './Switch.scss';
import clsx from 'clsx';

export interface ISwitchProps {
    /** Функция, вызываемая при изменении значения*/
    onChange?: (value: boolean) => void;
    /** Основной текст*/
    label?: ReactNode;
    /** Второстепенный текст*/
    helperText?: ReactNode;
    /** Значение по умолчанию
     * @default false
     */
    value?: boolean;
    /** залочен или нет
     * @default false
     */
    disabled?: boolean;
    /** размер
     * @default m
     */
    size?: 's' | 'm';
    /** Перевернуть положение контента
     * @default false
     */
    reverse?: boolean;
    /** Устанавливает компонент во всю ширину и добавляет расстояние между текстом и иконкой
     * @default false
     */
    between?: boolean;
    /** Класс */
    className?: string;
}

const Switch: FC<ISwitchProps> = ({
    label,
    helperText,
    value = false,
    disabled = false,
    onChange,
    size = 'm',
    reverse = false,
    between = false,
    className,
}: ISwitchProps) => {
    const [state, setState] = useState<boolean>(value);

    useEffect(() => {
        setState(value);
    }, [value]);

    const changeState = () => {
        if (!disabled) {
            onChange && onChange(!state);
            setState(!state);
        }
    };

    return (
        <button
            type="button"
            className={clsx(
                'rf-switch',
                `rf-switch--${size}`,
                disabled && 'rf-switch--disable',
                reverse && 'rf-switch--reverse',
                between && 'rf-switch--between',
                className,
            )}
            onClick={changeState}
        >
            <div className={clsx('rf-switch__toggle', state ? 'on' : 'off')}>
                <div className="rf-switch__circle" />
            </div>

            <div className="rf-switch__content">
                {label && <p className="rf-switch__label">{label}</p>}
                {helperText && <p className="rf-switch__helper-text">{helperText}</p>}
            </div>
        </button>
    );
};

export default Switch;
